import { useEffect, useRef } from "react";
import { useLocation } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { trackPageView } from "@/lib/track.functions";

const SESSION_KEY = "what.session.id";

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return `s_${Math.random().toString(36).slice(2, 12)}`;
  }
}

export function PageViewTracker() {
  const location = useLocation();
  const last = useRef<string>("");
  const track = useServerFn(trackPageView);

  useEffect(() => {
    const path = location.pathname;
    if (!path || path === last.current) return;
    if (path.startsWith("/admin") || path.startsWith("/_authenticated") || path.startsWith("/api")) return;
    last.current = path;

    const send = async () => {
      try {
        await track({
          data: {
            path,
            referrer: typeof document !== "undefined" ? document.referrer || null : null,
            session_id: getSessionId(),
          },
        });
      } catch {
        // analytics must never break the page
      }
    };
    const id = setTimeout(send, 0);
    return () => clearTimeout(id);
  }, [location.pathname, track]);

  return null;
}

